import { type ReactNode } from 'react';
import { Chip, IconButton } from '@zep-us/zus';
import { XBoldIcon } from '@zep-us/zus-icons';
import { LoaderCircle } from 'lucide-react';
import { cn } from '@/utils';
type AiBuilderAttachmentPreviewCardProps = {
  badge: string;
  badgeIcon?: ReactNode;
  children: ReactNode;
  className?: string;
  loading?: boolean;
  onPreview?: () => void;
  onRemove?: () => void;
  previewAriaLabel?: string;
  removeAriaLabel?: string;
  size: 'composer' | 'message';
};

/** 입력 중/전송 후 첨부가 공유하는 정방형 미리보기 표면. */
export const AiBuilderAttachmentPreviewCard = ({
  badge,
  badgeIcon,
  children,
  className,
  loading = false,
  onPreview,
  onRemove,
  previewAriaLabel,
  removeAriaLabel,
  size
}: AiBuilderAttachmentPreviewCardProps) => <div className={cn('relative shrink-0 overflow-visible', size === 'composer' ? 'size-[74px]' : 'size-[90px]', className)} data-sentry-component="AiBuilderAttachmentPreviewCard" data-sentry-source-file="AiBuilderAttachmentPreviewCard.tsx">
    <div className="relative size-full overflow-hidden rounded-[16px] border border-opacity bg-alternative">
      <div className="absolute inset-0 flex items-center justify-center overflow-hidden">
        {children}
      </div>

      {onPreview ? <button type="button" aria-label={previewAriaLabel} className="absolute inset-0 cursor-pointer rounded-[16px] hover:bg-opacity-black-2 focus-visible:focus-ring" onClick={onPreview} /> : null}

      {loading ? <span className="absolute inset-0 flex items-center justify-center bg-dimmed" aria-hidden="true">
          <LoaderCircle className="size-6 animate-spin text-inverse" />
        </span> : null}

      <Chip size="sm" leftSlot={badgeIcon} className="pointer-events-none absolute bottom-xs left-xs h-[22px] max-w-[calc(100%-16px)]" data-sentry-element="Chip" data-sentry-source-file="AiBuilderAttachmentPreviewCard.tsx">
        {badge}
      </Chip>
    </div>

    {onRemove ? <IconButton type="button" variant="transparent" intent="neutral" size="3xs" rounded="full" aria-label={removeAriaLabel} className="absolute -right-3xs -top-3xs cursor-pointer border-0 bg-default text-neutral shadow-sm ring-1 ring-[theme(borderColor.opacity.DEFAULT)] hover:bg-default" onMouseDown={event => event.preventDefault()} onClick={onRemove}>
        <XBoldIcon size="2xs" />
      </IconButton> : null}
  </div>;